import { motion } from "framer-motion";
import { ReactNode } from "react";

const PageTransition = ({ children }: { children: ReactNode }) => {
  return (
    <>
      {/* Wipe overlay */}
      <motion.div
        className="fixed inset-0 z-[9998] bg-foreground origin-left pointer-events-none"
        initial={{ scaleX: 1 }}
        animate={{ scaleX: 0 }}
        exit={{ scaleX: 1 }}
        transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
        style={{ transformOrigin: "right" }}
      />
      <motion.div
        className="fixed inset-0 z-[9997] bg-primary origin-left pointer-events-none"
        initial={{ scaleX: 1 }}
        animate={{ scaleX: 0 }}
        exit={{ scaleX: 1 }}
        transition={{ duration: 0.5, delay: 0.1, ease: [0.76, 0, 0.24, 1] }}
        style={{ transformOrigin: "right" }}
      />

      {/* Page content */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3, delay: 0.2 }}
      >
        {children}
      </motion.div>
    </>
  );
};

export default PageTransition;
